module.exports = __webpack_public_path__ + "static/media/jpg_icon.622310fb.svg";